<div *ngIf="message" [ngClass]="message.cssClass">{{message.text}}</div>
